import { render, staticRenderFns } from "./SellerInfo.vue?vue&type=template&id=50a18f7c&scoped=true&"
import script from "./SellerInfo.vue?vue&type=script&lang=js&"
export * from "./SellerInfo.vue?vue&type=script&lang=js&"
import style0 from "./SellerInfo.vue?vue&type=style&index=0&id=50a18f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a18f7c",
  null
  
)

export default component.exports